import React from 'react'
import SIZE from '../../global/Size'

import HeaderContainer from '../../components/header/HeaderContainer'
import HeaderTitle from '../../components/header/HeaderTitle'
import HeaderContentSmall from '../../components/header/HeaderContentSmall'
import SubHeading from '../../components/inner/venderProduct/SubHeading'
import FullImage from '../../components/inner/venderProduct/FullImage'
import ImageTextPanel from '../../components/inner/technologies/ImageTextPanel'

import BlackboxImage01 from '../../assets/technologies/blackboxImage01.png'
import AutomotiveImage02 from '../../assets/technologies/automotiveImage02.png'

import BlackboxTableImage01 from '../../assets/technologies/blackboxTableImage01.png';
import BlackboxTableImage02 from '../../assets/technologies/blackboxTableImage02.png';
import styled from 'styled-components'
import GoodixTable from '../../components/inner/venderProduct/GoodixTable'
import { useLanguage } from '../../context/LanguageContext';
import { siteCopy } from '../../i18n/landingCopy';

const BlackBox = () => {
  const { language } = useLanguage();
  const copy = siteCopy[language]?.pages?.technologies?.blackbox || siteCopy.en.pages.technologies.blackbox;
  const solutionCopy = copy.solution || siteCopy.en.pages.technologies.automotive.solution;
  const TouchPedHeaderData = copy.tableHeader || ["", "FULL HD 1920 * 1080", "QHD 2688 * 1944", "UHD 3840 * 2160"];
  const TouchPedRowData = copy.tableRows || [
    ["Sensor", "OS02H10, OS02C10", "OS04C20, OS05B10", "OS08G10, OS08C10"],
    ["HDR", "Staggered HDR / DCG + VS", "Staggered HDR", "DCG / LOFIC, DAG"]
  ];

  const renderLines = (lines = []) =>
    lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));

  return (
    <>
      <HeaderContainer>
        <HeaderTitle>{copy.title}</HeaderTitle>
        <div style={{height: '60px'}}/>
        <HeaderContentSmall>
          {renderLines(copy.introParagraphs)}
        </HeaderContentSmall>
        <HeaderContentSmall>
          {renderLines(copy.secondParagraphs)}
        </HeaderContentSmall>

        <div style={{width: '100%', height: 'auto', display: 'flex', justifyContent: 'space-between', paddingBottom: 30, alignItems: 'center'}}>
          <BlackBoxImage01 src={BlackboxImage01} alt='blackboxImage'/>
            <BlackboxInfo>
              <div style={{fontSize: SIZE.MEDIUM, paddingBottom: 10}}>
                  <span style={{fontSize: SIZE.X05LARGE, fontWeight: 600, paddingBottom: 30, display: 'flex'}}>
                    {copy.whatTitle}
                  </span>
                  <HeaderContentSmall>
                    {renderLines(copy.whatText)}
                  </HeaderContentSmall>
              </div>
              <div style={{fontSize: SIZE.MEDIUM}}>
                  <span style={{fontSize: SIZE.X05LARGE, fontWeight: 600, paddingBottom: 30, display: 'flex'}}>
                    {copy.whyTitle}
                  </span>
                  <HeaderContentSmall>
                    {renderLines(copy.whyText)}
                  </HeaderContentSmall>
              </div>
            </BlackboxInfo>
        </div>

        <SummaryContainer>
          <div style={{height: '60px'}}/>
        </SummaryContainer>

        <SummaryContainer>
          <SubHeading>{copy.legalTitle}</SubHeading>
        </SummaryContainer>
        <FullImage Item={BlackboxTableImage01}/>

        <SummaryContainer>
          <SubHeading>{copy.imageSensorTitle}</SubHeading>
        </SummaryContainer>
        
        <TableBox>
          <GoodixTable HeaderData={TouchPedHeaderData} RowData={TouchPedRowData}/>
        </TableBox>
        
        <SubHeading>{copy.solutionTitle}</SubHeading>
        <ImageTextPanel 
          Image={AutomotiveImage02}
          Title={solutionCopy.title}
          Link={solutionCopy.link}
          Text={<>{renderLines(solutionCopy.text)}</>}/>

      </HeaderContainer>
    </>
  )
}

const BlackBoxImage01 = styled.img`
  width: 60%;
  object-fit: contain;

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    display: none;
  }

  /* 450px 미만 */
  @media (max-width: 449px) {
    display: none;
  }
`

const BlackboxInfo = styled.div`
  width: 38%;
  display: flex;
  flex-direction: column;
  
  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    width: 100%;
  }
  
  /* 450px 미만 */
  @media (max-width: 449px) {
    width: 100%;
  }
  `

const SummaryContainer = styled.div`
  /* 0px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    display: none;
  }
`

const TableBox = styled.div`
  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    display: none;
  }
  
  /* 450px 미만 */
  @media (max-width: 449px) {
    display: none;
  }
`

export default BlackBox
